import PropTypes from "prop-types";
import { MyRequestsNotificationDot } from "./MyRequestsNotificationDot";

export function MyRequestsNavLabel({
  children,
  showNotification = false,
  ringClassName = "ring-white",
  ringColor = null,
  className = "",
}) {
  return (
    <span className={`relative inline-flex items-center pr-1 ${className}`}>
      {children}
      {showNotification ? (
        <MyRequestsNotificationDot
          ringClassName={ringClassName}
          ringColor={ringColor}
        />
      ) : null}
    </span>
  );
}

MyRequestsNavLabel.propTypes = {
  children: PropTypes.node.isRequired,
  showNotification: PropTypes.bool,
  ringClassName: PropTypes.string,
  ringColor: PropTypes.string,
  className: PropTypes.string,
};
